<template>

    <div>
        <header-component></header-component>
        <search-view-component></search-view-component>
        <div class="container">
            <div class="row justify-content-center">
                <div class="input-group mb-3">
                    <input type="text" class="form-control" v-model="zip" placeholder="Enter Zip" aria-label="" aria-describedby="button-addon2">
                    <button class="btn btn-outline-secondary"  @click="getOffersToDisplayInMap" type="button" id="button-addon2">Button</button>
                </div>
                <div style="height: 250px" class="col-md-12">
                    <map-component :offerLocations = "offerLocations" :mapCenter = "mapCenter"> </map-component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MapComponent from './MapComponent.vue';
    import HeaderComponent from './HeaderComponent.vue';
    import SearchViewComponent from './search/SearchViewComponent.vue';
    export default {
        name: "DashboardComponent",
        components: {
            MapComponent,
            HeaderComponent,
            SearchViewComponent
        },
        data() {
            return {
                zip: null,
                user: null,
                offerLocations: [],
                mapCenter: {}
            }
        },
        methods: {
            getOffersToDisplayInMap(e) {

                e.preventDefault();

                    axios.post(this.apiEndPoints.matchedOffers, {
                        zip: this.zip,
                        getOffersForMap: 1,
                        PageNumber: 1,
                        ItemsPerPage: 20
                    })
                        .then(response => {

                            let matchedOffers = response?.data?.Response?.Items?.MatchedOffer;

                            if(matchedOffers !==  undefined) {
                                this.offerLocations = matchedOffers.map(a => {
                                    let innerObj = a.Merchant.Addresses.Address[0];
                                    innerObj['MerchantName'] = a.Merchant.Name;
                                    return innerObj;
                            });
                            }

                            let mapCenter = response?.data?.Response?.MapCenter;

                            if(mapCenter !== undefined && mapCenter.longitude && mapCenter.latitude) {
                                this.mapCenter = mapCenter;
                            }

                            if(response.data && response.data.status) {

                                if(response.data.status == 'success') {
                                   // console.log(response.data);

                                    //
                                   // console.log()
                                } else if(response.data.message) {
                                    this.errors.push(response.data.message);
                                } else {
                                    this.errors.push('An error occurred. Please try again!');
                                }
                            }
                        })
                        .catch(error => {
                            console.error(error.response);
                        });
            }
        },
        mounted() {

            if(localStorage.getItem('user_obj')) {
                this.user = JSON.parse(localStorage.getItem('user_obj'));
                this.zip = this.user.postal_code;
            }
        }
    }
</script>

<style scoped>

</style>
